import {
  Button,
  Copy,
  Heading,
  SvgCircleX,
} from '@grubhubprod/gh-cookbook-react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { useInitialModalAnalytics } from 'src/components/selfService/features/OrderHistory/ZipDownload/hooks/InitialModalAnalytics';
import { ZipFileFilters } from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { FilterInformation } from './FilterInformation';

interface TooManyReceiptsModalProps {
  maximumReceiptsAllowed: number;
  filters: ZipFileFilters;
  onClose: () => void;
}

export function TooManyReceiptsModal({
  maximumReceiptsAllowed,
  filters,
  onClose,
}: TooManyReceiptsModalProps): JSX.Element {
  useInitialModalAnalytics({
    eventlabel: 'max receipts error',
  });
  return (
    <Modal size="xs">
      <Square inset="md">
        <Stack y="sm">
          <Heading variant="h1">Download receipts</Heading>
        </Stack>
        <Stack
          aria-label="Error"
          y="sm"
          color="danger"
          display="flex"
          alignItems="center"
        >
          <Copy variant="body" color="danger">
            <Stack x="sm" height="100%">
              <SvgCircleX size="20px" color="secondaryText" />
            </Stack>
          </Copy>
          Please pick a shorter date range or different search term. Your
          current selection goes over our {maximumReceiptsAllowed} receipt
          maximum.
        </Stack>
        <Stack aria-label="Filters">Receipts for orders:</Stack>
        <Stack as="ul" y="md">
          <FilterInformation filters={filters} />
        </Stack>
        <Stack width="100%">
          <Button
            block
            variant="secondary"
            buttonSize="medium"
            onClick={onClose}
          >
            Got it
          </Button>
        </Stack>
      </Square>
    </Modal>
  );
}
